<template>
  <v-container fluid>
    <v-row>
      <v-btn-toggle v-model="hours" mandatory class="ma-3">
        <v-btn small :value="24">24 h</v-btn>
        <v-btn small :value="48">48 h</v-btn>
        <v-btn small :value="168">7 Tage</v-btn>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <v-btn class="ma-3" icon :loading="loading" @click="load">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-row>

    <!-- Verbrauchs-Übersicht -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Verbrauch</v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Gerät</th>
                  <th class="text-right">Jetzt</th>
                  <th class="text-right">Heute</th>
                  <th class="text-right">Gestern</th>
                  <th class="text-right">7 Tage</th>
                  <th class="text-right">30 Tage</th>
                  <th class="text-right">Gesamt</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="plug in plugs" :key="plug.device_id">
                  <td class="text-left">
                    <v-icon small :color="plug.on ? 'orange' : ''" class="mr-1">mdi-power-socket-de</v-icon>
                    {{ plug.display_name }}
                  </td>
                  <td class="text-right">{{ plug.apower != null ? plug.apower.toFixed(1) + ' W' : '–' }}</td>
                  <td class="text-right">{{ kwh(plug.kwh_today) }}</td>
                  <td class="text-right">{{ kwh(plug.kwh_yesterday) }}</td>
                  <td class="text-right">{{ kwh(plug.kwh_7d) }}</td>
                  <td class="text-right">{{ kwh(plug.kwh_30d) }}</td>
                  <td class="text-right">{{ kwh(plug.kwh_total) }}</td>
                </tr>
                <tr v-if="plugs.length > 1" class="font-weight-bold">
                  <td class="text-left">Gesamt</td>
                  <td class="text-right">{{ total('apower').toFixed(1) }} W</td>
                  <td class="text-right">{{ kwh(total('kwh_today')) }}</td>
                  <td class="text-right">{{ kwh(total('kwh_yesterday')) }}</td>
                  <td class="text-right">{{ kwh(total('kwh_7d')) }}</td>
                  <td class="text-right">{{ kwh(total('kwh_30d')) }}</td>
                  <td class="text-right">{{ kwh(total('kwh_total')) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Leistungskurven (Backend-gerendertes PNG) -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Leistungskurven</v-card-title>
          <v-card-text>
            <img
                v-if="!chartFailed"
                :src="chartUrl"
                alt="Leistungskurven"
                style="width: 100%"
                @error="chartFailed = true"
            />
            <div v-else class="text--secondary">
              Noch keine Stromdaten vorhanden — das Backend sammelt minütlich,
              kurz nach einem Neustart ist das Chart noch leer.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { smarthausApi } from '../../services/smarthaus'

export default {
  name: 'PowerView',
  data: () => ({
    plugs: [],
    hours: 24,
    chartUrl: '',
    chartFailed: false,
    loading: false,
  }),
  watch: {
    hours() { this.refreshChart() },
  },
  mounted() {
    this.load()
  },
  methods: {
    kwh(v) { return v != null ? v.toFixed(2) + ' kWh' : '–' },
    total(key) {
      return this.plugs.reduce((sum, p) => sum + (p[key] || 0), 0)
    },
    refreshChart() {
      this.chartFailed = false
      this.chartUrl = smarthausApi.powerChartUrl(this.hours)
    },
    async load() {
      this.loading = true
      this.refreshChart()
      try {
        const data = await smarthausApi.powerSummary()
        this.plugs = data.plugs
      } catch (e) {
        console.error('[PowerView]', e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>

</style>
